/* eslint-disable @typescript-eslint/no-explicit-any */
import { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { seoAdminAccessControl } from '../access-control/seoAdminAccess.configuration'

const SeoSettingsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SeoSettingsPage" */
      '../pages/seo-settings/SeoSettingsPage'
    )
)

const SeoAdminWrapper = lazy(() =>
  import('../components/SeoAdminWrapper').then(m => ({
    default: m.SeoAdminWrapper,
  }))
)

// Note that this is intentionally not a component. Do not wrap <DomainRoute> with anything else, as it will cause issues with the parent <Switch />
// More information here https://v5.reactrouter.com/web/api/Switch/children-node
//
// Admin (marketplace) surface: no retailer/site picker, so SeoAdminWrapper stands in for
// the partner route's SeoScopeWrapper purely to mount the HeaderTitlePortalTarget the
// page's HeaderPortal renders into. Registered in the domain's `admin` router bucket.
export const seoAdminRouter = (
  <DomainRoute route="app-admin-seo" accessControl={seoAdminAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="app-admin-seo-settings"
        component={SeoSettingsPage as ComponentType<any>}
        scopePickerComponent={SeoAdminWrapper as ComponentType<any>}
      />
    </DashSwitch>
  </DomainRoute>
)
